export const defaultStyle = {
    mobileNavParentIN:"mobileNavParentIN darkPart bg-darkgray",
    mobileNavParentINUL:"mobileNavParentINUL",
}